import { authInstance } from './axios';
import { filterParams } from '../assets/helpers/funciones';
let url = process.env.REACT_APP_API_URL;

export const statesService = {
  getStates: async (params) => {
    const response = await authInstance
      .get(`${url}/states/list?` + new URLSearchParams(filterParams(params)))
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  listStatesByFilter: async ({ stateIds = [] } = {}) => {
    const response = await authInstance
      .post(`${url}/states/list`, { stateIds })
      .then(async (response) => { return response; })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  listCitiesByFilter: async ({ skip = 0, limit = 10, stateIds = [], citiesIds = [] } = {}) => {
    const body = { skip, limit };
    if (stateIds.length > 0) body.stateIds = stateIds;
    if (citiesIds.length > 0) body.citiesIds = citiesIds;
    const response = await authInstance
      .post(`${url}/cities/list`, body)
      .then(async (response) => { return response; })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  listMunicipalitiesByFilter: async ({ skip = 0, limit = 10, stateIds = [], cityIds = [], municipalityIds = [] } = {}) => {
    const body = { skip, limit };
    if (stateIds.length > 0) body.stateIds = stateIds;
    if (cityIds.length > 0) body.cityIds = cityIds;
    if (municipalityIds.length > 0) body.municipalityIds = municipalityIds;
    const response = await authInstance
      .post(`${url}/municipalities/list`, body)
      .then(async (response) => { return response; })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  createState: async (data) => {
    const response = await authInstance
      .post(`${url}/states`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  updateState: async (stateId, data) => {
    const response = await authInstance
      .put(`${url}/states/${stateId}`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  /**
   * Cities for dropdowns. Sends `isActive=true` in the query when `isActive` is true (default).
   * @param {string} [stateId]
   * @param {boolean} [isActive=true] When false, omits `isActive` from the query string.
   */
  getCities: async (stateId, isActive) => {
    const params = filterParams({
      ...(stateId && { stateId }),
      ...(isActive ? { isActive: true } : {}),
    });
    const response = await authInstance
      .get(`${url}/cities/list?` + new URLSearchParams(filterParams(params)))
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  /**
   * @param {string|number|object} [arg] stateId (legacy) or { stateId?, skip?, limit? }
   */
  getCitiesTable: async (params) => {
    const response = await authInstance
      .get(`${url}/cities/list?` + new URLSearchParams(filterParams(params)))
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  createCity: async (data) => {
    const response = await authInstance
      .post(`${url}/cities/create`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  updateCity: async (cityId, data) => {
    const response = await authInstance
      .patch(`${url}/cities/${cityId}`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  /**
   * @param {string|number|object} [arg] cityId (legacy) or { cityId?, skip?, limit? }
   */
  getMunicipalitiesTable: async (params) => {
    const response = await authInstance
      .get(
        `${url}/municipalities/list?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  createMunicipality: async (data) => {
    const response = await authInstance
      .post(`${url}/municipalities/create`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  updateMunicipality: async (municipalityId, data) => {
    const response = await authInstance
      .patch(`${url}/municipalities/${municipalityId}`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },

  /**
   * Municipalities for dropdowns. Sends `isActive=true` in the query when `isActive` is true (default).
   * @param {string} [cityId]
   * @param {boolean} [isActive=true] When false, omits `isActive` from the query string.
   */
  getMunicipalities: async (cityId, isActive) => {
    const params = filterParams({
      ...(cityId && { cityId }),
      ...(isActive ? { isActive: true } : {}),
    });
    const response = await authInstance
      .get(`${url}/municipalities/list?` + new URLSearchParams(params))
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });
    return response;
  },
};
